export const DEFAULT_TIME_FILTER = -1

export enum SOURCE {
  SUPPLY = 'new-summary/supply',
  COLLECTION = 'new-summary/collection',
  PENDINGDUE = 'new-summary/pending-due',
  ACCOUNTS = 'new-summary/accounts'
}
